import React from 'react';
import { Navigate } from 'react-router-dom';
import { Spinner } from '@/components/ui';
import { useAuth } from '../../../contexts/AuthContext';
import { usePermissions } from '../../../hooks/usePermissions';

/**
 * Redirects `/areas` to the first areas section the user may view.
 */
const AreasDefaultRedirect: React.FC = () => {
  const { loading } = useAuth();
  const { hasPermission } = usePermissions();

  if (loading) {
    return (
      <div className="tw-flex tw-justify-center tw-items-center" style={{ minHeight: '200px' }}>
        <Spinner animation="border" role="status">
          <span className="tw-sr-only">Loading...</span>
        </Spinner>
      </div>
    );
  }

  if (hasPermission('area:service_view')) {
    return <Navigate to="/areas/service" replace />;
  }
  if (hasPermission('area:foreman_view')) {
    return <Navigate to="/areas/foreman" replace />;
  }
  if (hasPermission('area:contract_view')) {
    return <Navigate to="/areas/contract" replace />;
  }

  return <Navigate to="/home" replace />;
};

export default AreasDefaultRedirect;
